(() => {
  const root = document.documentElement;
  let scheduled = false;

  const updateHeaderState = () => {
    root.classList.toggle('tm-header-scrolled', window.scrollY > 110);
    scheduled = false;
  };

  const requestUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateHeaderState);
  };

  updateHeaderState();
  window.addEventListener('scroll', requestUpdate, { passive: true });
})();

(() => {
  const collectionUrls = {
    HOMBRE: '/collections/hombre?view=hombre',
    MUJER: '/collections/mujer?view=mujer',
  };

  const updateCollectionLinks = () => {
    document
      .querySelectorAll('#header-component a, .tm-footer a, .tm-category-list a')
      .forEach((link) => {
        const label = (link.textContent || '').trim().toLocaleUpperCase('es-ES');
        const collectionUrl = collectionUrls[label];

        if (collectionUrl) {
          link.setAttribute('href', collectionUrl);
        }
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCollectionLinks, { once: true });
  } else {
    updateCollectionLinks();
  }
})();
